var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 57,
    viewBox: "0 0 14 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 57,
    height: 14,
    rx: 7,
    transform: "rotate(90 14 0)",
    fill: "#1D2123"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.8776L11 22L3 13.1224L3 7L11 15.8776Z",
    fill: "#FA9338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.8776L11 32L3 23.1224L3 17L11 25.8776Z",
    fill: "#FA9338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 35.8776L11 42L3 33.1224L3 27L11 35.8776Z",
    fill: "#FA9338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45.8776L11 52L3 43.1224L3 37L11 45.8776Z",
    fill: "#FA9338"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareIcon);
export default __webpack_public_path__ + "static/media/rare-icon.7259986be690c7f14543f10b11ca4e24.svg";
export { ForwardRef as ReactComponent };